export enum EntityColorEnum {
  shipment = '$palette-blue-500',
  order = '$palette-pink-500',
}
